export default {"en-US": __webpack_public_path__ + "i18n/en-US.6a91cb35.i18next.json"};